import type { Theme, Objective } from './types'

export const themes: Theme[] = [
  { id: 'A', name: 'Adoption', subtitle: 'Matou Technologies Adoption', description: 'Growing the reach and use of Matou Technologies across Indigenous communities worldwide.', colorLight: '#E4CCFF', colorDark: '#B266FF', icon: 'Users' },
  { id: 'B', name: 'Platform', subtitle: 'Platform & Infrastructure', description: 'Building the Indigenous cloud platform, governance tools, and community-owned hosting.', colorLight: '#9AC7BF', colorDark: '#67AB9F', icon: 'Server' },
  { id: 'C', name: 'Economy', subtitle: 'Economic Sustainability', description: 'Creating a self-sustaining economic model through token systems and treasury governance.', colorLight: '#ADCEFF', colorDark: '#7EA6E0', icon: 'Coins' },
  { id: 'D', name: 'Growth', subtitle: 'Organisational Growth', description: 'Growing the contributor base, establishing the Elders Council, and securing funding.', colorLight: '#d5e8d4', colorDark: '#82b366', icon: 'TrendingUp' },
]

export const objectives: Objective[] = [
  {
    id: 'A1',
    theme: 'A',
    description: 'Share our technology blueprint with the world',
    timeframe: 'Q2 2026',
    status: 'in-progress',
    dependencies: ['D1'],
  },
  {
    id: 'A2',
    theme: 'A',
    description: 'Get communities up and running with Mātou tools for their own governance',
    timeframe: 'End of 2027',
    status: 'not-started',
    dependencies: ['A1', 'B2', 'D2'],
  },
  {
    id: 'A3',
    theme: 'A',
    description: 'Build a thriving network of people using Mātou tools every day',
    timeframe: 'End of 2028',
    status: 'not-started',
    dependencies: ['A2', 'B3', 'B4'],
  },
  {
    id: 'B1',
    theme: 'B',
    description: 'Share the first version of the Indigenous cloud platform with communities',
    timeframe: 'Q3 2026',
    status: 'in-progress',
    dependencies: ['A1', 'D1', 'D4'],
  },
  {
    id: 'B2',
    theme: 'B',
    description: 'Get the first version of our community platform out the door — proposals, voting, treasury and all',
    timeframe: 'Q4 2026',
    status: 'not-started',
    dependencies: ['A1', 'B1', 'D1'],
  },
  {
    id: 'B3',
    theme: 'B',
    description: 'Make our tools work on mobile for communities with limited internet',
    timeframe: '2027',
    status: 'not-started',
    dependencies: ['B2', 'A2'],
  },
  {
    id: 'B4',
    theme: 'B',
    description: 'Hand the keys over — communities hosting their own infrastructure',
    timeframe: '2028',
    status: 'not-started',
    dependencies: ['B1', 'B3', 'A2', 'C2'],
  },
  {
    id: 'C1',
    theme: 'C',
    description: 'Launch a token system so we can keep the lights on beyond our current funding',
    timeframe: 'Q4 2026',
    status: 'not-started',
    dependencies: ['B2', 'D3'],
  },
  {
    id: 'C2',
    theme: 'C',
    description: 'Get the treasury sustaining itself through platform fees and bonding curves',
    timeframe: '2028',
    status: 'not-started',
    dependencies: ['C1', 'A3', 'B4'],
  },
  {
    id: 'C3',
    theme: 'C',
    description: 'Start funding community projects straight from the treasury',
    timeframe: '2029',
    status: 'not-started',
    dependencies: ['C2'],
  },
  {
    id: 'D1',
    theme: 'D',
    description: 'Grow our family of contributors across all three houses',
    timeframe: 'End of 2026',
    status: 'in-progress',
    dependencies: [],
  },
  {
    id: 'D2',
    theme: 'D',
    description: 'Stand up the Elders Council with community and tribal group representation',
    timeframe: '2027',
    status: 'not-started',
    dependencies: ['D1'],
  },
  {
    id: 'D3',
    theme: 'D',
    description: 'Keep chasing grants and funding until the treasury can hold its own',
    timeframe: '2026-2027',
    status: 'in-progress',
    dependencies: [],
  },
]
